import { flattenJsonToSchema } from './adminFormUtils';

const FLAT_SCHEMA_KEYS = new Set([
  'privacy',
  'contact',
  'about',
  'home-page',
  'app-promo',
  'auth',
  'profile',
  'sellcar',
  'valuation',
  'compare',
  'carTrust',
  'emi',
  'warranty',
]);

const FLAT_DATA_KEYS = {};

export const moduleUsesFlatSchema = (module) =>
  Boolean(module?.useFlatSchema || FLAT_SCHEMA_KEYS.has(module?.schemaKey || module?.key));

export const buildModuleSchema = (module, data = null, staticSchema = []) => {
  const baseFields = staticSchema.filter((field) => field.type !== 'json');
  if (!module || !moduleUsesFlatSchema(module) || !data) {
    return baseFields;
  }

  const key = module.schemaKey || module.key;
  const flatSources = FLAT_DATA_KEYS[key];

  let flatFields = [];
  if (flatSources) {
    flatSources.forEach((sourceKey) => {
      if (data[sourceKey] != null) {
        flatFields = flatFields.concat(flattenJsonToSchema(data[sourceKey], sourceKey));
      }
    });
  } else {
    flatFields = flattenJsonToSchema(data);
  }

  const staticPaths = new Set(baseFields.map((field) => field.name));
  const seenSections = new Set(
    baseFields.filter((field) => field.type === 'section').map((field) => field.name)
  );
  const uniqueFlat = flatFields.filter((field) => {
    if (field.type === 'section') {
      if (seenSections.has(field.name)) return false;
      seenSections.add(field.name);
      return true;
    }
    return !staticPaths.has(field.name);
  });

  return [...baseFields, ...uniqueFlat];
};
